module.exports = __webpack_public_path__ + "static/spinner-2s-120px-9886d563eb23543c828794a0ceed8dbb.gif";